import DOMPurify from 'isomorphic-dompurify';

/**
 * Sanitize HTML content for safe rendering via dangerouslySetInnerHTML.
 * Allows Tailwind classes and standard formatting tags.
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ['class'],
    USE_PROFILES: {
      html: true,
      mathMl: false,
      svg: false,
      svgFilters: false,
    },
  });
}
